import React from 'react';
import { Stack } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { InputField, InterestInputField } from 'components/form';

import { SendApplicationFormValues } from '../../types';

export const FinanceSection = () => {
  const { control } = useFormContext<SendApplicationFormValues>();

  return (
    <Stack direction="row" gap="0.5rem" pt="0.75rem">
      <InputField name="finance.term" control={control} label="Term" inputProps={{ variant: 'outlined' }} />

      <InterestInputField label="Rate" name="finance.rate" control={control} textFieldProps={{ variant: 'outlined' }} />

      <InterestInputField
        label="Down Payment"
        control={control}
        name="finance.downPayment"
        textFieldProps={{ variant: 'outlined' }}
      />
    </Stack>
  );
};
